module.exports = __webpack_public_path__ + "static/media/teacher-student.025dec66.png";